/*
 * Ryan O'Dowd
 * 2025-05-22
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    container: {
      color: colors.dialogText,
      fontSize: globalScale * 22,
      fontFamily: fonts.primaryBold,
      marginTop: globalScale * 16,
      marginRight: globalScale * 16,
      marginBottom: globalScale * 16,
      marginLeft: globalScale * 16,
    },
  };
};

export default getStyles;
